import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import * as theme from '../../../theme';
import Heading from "../../Heading";
import SearchBox from "../../SearchBox";
import TruCard from "../../TruCard";
import { sortPeople } from "../../../functions/Sorting";
import { Button } from "@mui/material";
import { ArrowBack, ArrowForward } from "@mui/icons-material";

export default function ClientList(props) {
  const [clientList, setClientList] = useState([]);
  const [clientsOnDisplay, setClientsOnDisplay] = useState(sortPeople([]));
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 12;
  const propertyList = ['firstName', 'lastName', 'email'];
  const navigate = useNavigate();

  useEffect(() => {
    setClientsOnDisplay(sortPeople(clientList));
    setCurrentPage(1);
  }, [clientList]);

  useEffect(() => {
    setClientList(props.clientList);
  }, [props.clientList])

  async function findClients(searchText) {
    if (searchText === '') {
      setClientsOnDisplay(sortPeople(clientList));
      setCurrentPage(1);
      return;
    } else if (searchText.length > 2) {
      const clientsToDisplay = await clientList.reduce((cList, c) => {
        if (propertyList.some(prop => c[prop] != null && c[prop].toLowerCase().includes(searchText.toLowerCase()))) {
          cList.push(c);
        }
        return cList;
      }, []);
      setClientsOnDisplay(sortPeople(clientsToDisplay));
      setCurrentPage(1);
    }
    return;
  }

  function goToClient(id) {
    navigate(`/clients/${id}`);
  }

  function addClient() {
    navigate(`/clients/add/${props.practitionerId}`);
  }

  const totalPages = Math.ceil(clientsOnDisplay.length / pageSize);
  const displayedClients = clientsOnDisplay.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  return (
    <div>
      <Heading title={'Clients'} subHeading={true} icon={props.cardOnFile && props.onboardingComplete ? 'add' : null} iconAction={() => props.cardOnFile && props.onboardingComplete ? addClient() : null} />
      <TruCard title={'Client List'}>
        <SearchBox searchText={(searchText) => findClients(searchText)} />
        <div style={theme.Container.listRow}>
          {displayedClients != null && displayedClients.map(c => {
            return (
              <div 
                key={c.id}
                className='hoverCard'
                style={theme.Cards.card}
                onClick={() => goToClient(c.id)}
              >
                <div style={theme.Cards.client}>{c.lastName}, {c.firstName}</div>
                <div style={theme.Cards.clientDetail}>{c.email}</div>
              </div>
              )
          })}
        </div>
        {clientsOnDisplay.length > 0 && (
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '20px' }}>
            <Button
              variant="contained"
              color="primary"
              sx={{ flex: 0.3, maxWidth: 60 }}
              onClick={() => setCurrentPage(currentPage - 1)}
              disabled={currentPage === 1} 
            >
              <ArrowBack />
            </Button>
            <span>{currentPage} of {totalPages}</span>
            <Button
              variant="contained"
              color="primary"
              sx={{ flex: 0.3, maxWidth: 60 }}
              onClick={() => setCurrentPage(currentPage + 1)}
              disabled={currentPage === totalPages} 
            >
              <ArrowForward />
            </Button>
          </div>
        )}
      </TruCard>
    </div>
  );
}